// extracted by mini-css-extract-plugin
export var title = "cart-module--title--3qvMZ";
export var wrap = "cart-module--wrap--1mWUB";
export var table = "cart-module--table--1GgUd";
export var totals = "cart-module--totals--1cbPs";
export var summary = "cart-module--summary--3DX23";
export var summaryItem = "cart-module--summaryItem--33RJ5";
export var grandTotal = "cart-module--grandTotal--ysUv3";
export var checkoutButton = "cart-module--checkoutButton--1__7z buttons--button--1nSrK";
export var labelColumn = "cart-module--labelColumn--2HVtO";